import React from 'react';
import ReactDOM from 'react-dom';
import ReCAPTCHA from 'react-google-recaptcha'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function onChange(value) {
  console.log("Woot!");
}

ReactDOM.render(
  <React.StrictMode>
    <App />
    <ReCAPTCHA
      sitekey="6LdnXgIaAAAAAMnkHDEGMrNfnFzGjGNMR-7vuxAZ"
      onChange={onChange}
    />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
